import { render, staticRenderFns } from "./SubmissionTogglerModal.vue?vue&type=template&id=cccf12d8&scoped=true&"
import script from "./SubmissionTogglerModal.vue?vue&type=script&lang=js&"
export * from "./SubmissionTogglerModal.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionTogglerModal.vue?vue&type=style&index=0&id=cccf12d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cccf12d8",
  null
  
)

export default component.exports